// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PCompassOutlinedSvg from "@fishx/icons-svg/es/asn/PCompassOutlined";
import FishxIcon from '../components/FishxIcon';

var PCompassOutlined = function PCompassOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PCompassOutlinedSvg
  }));
};

PCompassOutlined.displayName = 'PCompassOutlined';
export default React.forwardRef(PCompassOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PCompassOutlined.js
// module id = 3308
// module chunks = 0